import React from 'react';
import { CART_LINK } from '../constants/content';
import { trackPixel } from '../utils/pixel';
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
}

/**
 * The single buy button used across the page: mustard background, bordó text.
 * Fires the Meta Pixel "AddToCart" event (when loaded), then goes to checkout.
 */
export function CtaButton({
  children,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-lg b640:text-xl b820:text-2xl' : 'px-5 py-3 text-base b640:text-lg';
  return <a href={CART_LINK} onClick={() => trackPixel('AddToCart')} className={`inline-flex w-full items-center justify-center gap-2 rounded-xl bg-mustard text-center font-display font-700 uppercase leading-tight tracking-wide text-bordo shadow-[0_6px_0_0_#B8901A] transition-transform duration-150 hover:-translate-y-0.5 hover:bg-mustard-soft focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-mustard active:translate-y-0 ${sizing} ${className}`} data-id="element-55" data-mp="10amxso3zyeva">
      {children}
    </a>;
}